import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Section } from '@cbridge-tools/section';
import { StreamForm } from '@cbridge-modules/stream-form';

export const StreamSettingsSection: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Section title={t('text:configPage.streams.section.settings')}>
      <StreamForm />
    </Section>
  );
};
